import { apiClient } from './client';

/**
 * 이상 근태 — **`company-today` 의 숫자를 사람으로 펼친 것** (2026-08-29 · 판 F).
 *
 * 서버: `apps/chat-server/src/modules/hr/attendance-today.routes.ts`.
 *
 * ★★ **세는 규칙이 요약 다섯 칸과 한 벌이다** — 퇴근 누락은 **어제 이전 7일**, 미출근은 **오늘**.
 *    같은 화면의 위아래가 다른 수를 말하면 둘 다 못 믿게 된다.
 * ★ **전사를 보는 사람만**(팀장은 403) · 옛 서버에는 없다(404) — 부르는 쪽이 실패를 삼킨다.
 * ★ 담기는 것은 **시각 · 상태뿐**이다. 휴가 종류·사유는 서버가 아예 안 준다.
 */
export type AnomalyKind = 'MISSING_CHECKOUT' | 'ABSENT';

export interface AnomalyRow {
  kind: AnomalyKind;
  /** 그 이상이 있는 날 — 미출근은 오늘, 퇴근 누락은 그 날짜. */
  workDate: string;
  userId: string;
  name: string;
  position: string | null;
  teamName: string | null;
  divisionName: string | null;
  /** 퇴근 누락일 때 그날 출근 시각 `HH:MM`. 미출근이면 null. */
  checkIn: string | null;
  baseStart: string | null;
  baseEnd: string | null;
}

export interface AnomaliesDto {
  date: string;
  /** 퇴근 누락을 며칠 전까지 훑었나. */
  days: number;
  rows: AnomalyRow[];
  counts: { missingCheckout: number; absent: number; total: number };
  tzOffsetMinutes: number;
}

export async function fetchAnomalies(): Promise<AnomaliesDto> {
  const { data } = await apiClient.get<AnomaliesDto>('/hr/attendance/anomalies');
  return data;
}
